<template>
  <div :id="id" class="xterm" style="height: 400px;"></div>
</template>
<script>
import { defineComponent, onMounted, onBeforeUnmount, watch, nextTick, ref } from "vue";
//xterm
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
import "xterm/css/xterm.css";
import "xterm/lib/xterm.js";

export default defineComponent({
  name: "XTerm",
  props: {
    type: String,
    width: Number,
    firstData: String
  },
  setup(props) {
    let xterm = null;
    let type = "";
    let width = ref(0);
    let id = ref("logxterm");
    const fitAddon = new FitAddon();
    type = type ? type : props.type;
    if (type == "log") {
      id.value = "logxterm";
    }
    function initTerm() {
      width.value = width.value ? width.value : props.width;
      let rows = width.value / 12;
      xterm = new Terminal({
        rows: parseInt(rows),
        cursorStyle: "underline", //光标样式
        cursorBlink: true, // 光标闪烁
        convertEol: true, //启用时，光标将设置为下一行的开头
        disableStdin: true, //是否应禁用输入。
        theme: {
          foreground: "white", //字体
          background: "#334963", //背景色
          cursor: "help", //设置光标
        },
      });

      xterm.loadAddon(fitAddon);
      xterm.open(document.getElementById(id.value));
      fitAddon.fit();
      if (!xterm._initialized) {
        xterm._initialized = true;
      }
      if (type == "log") {
        if (props.firstData) xterm.write(props.firstData);
      }
      window.addEventListener("resize", function () {
        fitAddon.fit();
      });
    }
    function fit() {
      fitAddon.fit();
    }
    function dispose() {
      xterm.dispose();
    }
    function wirteLog(e) {
      if(xterm) xterm.write(e);
      fit();
    }
    watch(props, (newProps) => {
      type = newProps.type;
      width.value = newProps.type.width;
    });
    onBeforeUnmount(() => {
      dispose();
    });
    return {
      initTerm,
      fit,
      dispose,
      id,
      wirteLog
    };
  },
});
</script>

